// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2xsrV","footer":"ModalInfo_footer__2bhN1"};